/**
 * Full-page navigation (the session redirects and the role guards reload the
 * page). Isolated in its own module so tests can spy on it without touching
 * `window.location`.
 */
export const hardNavigate = (path: string): void => {
  window.location.assign(path);
};
